<template>
  <div class="container-fluid h-100 d-flex flex-column flex-fill">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-12 col-md-9">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <!-- Nested Row within Card Body -->
              <div class="row">
                <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div class="col-lg-6">
                  <div class="p-5">
                    <div class="text-center">
                      <h1 class="h4 text-gray-900 mb-4">Wilkommen zurück!</h1>

                      <a
                        @click="login"
                        class="btn btn-primary btn-user btn-block"
                        >Login</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { AuthenticationContext } from "@/auth/msal-context";

export default {
  name:"LoginComponent",
  methods: {
    login() {
      return AuthenticationContext.login();
    },
  },
};
</script>
<style scoped>
.flex-fill {
  min-height: 100vh;
}
.bg-login-image{
  background: url("~@/assets/img/icons/logo.png");
  background-position: center;
  background-size: 200px;
    background-repeat: no-repeat;

}
</style>
